module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "py-4 mx-2 d-flex align-start space-between fontS14 wrap"
  }, [_c('div', {
    staticClass: "big mx-3 mb-1"
  }, [_c('h3', {
    staticClass: "uppercase fontS14 fontAvenirBold ml-2",
    style: (("color: " + (_vm.globalColors.primary)))
  }, [_vm._v("Resumen de tu pedido")]), _vm._v(" "), _c('address-data'), _vm._v(" "), _c('billing-data')], 1), _vm._v(" "), _c('div', {
    staticClass: "shoping-summary"
  }, [_c('div', {
    staticClass: "card-summary mb-3 py-1"
  }, [_c('h3', {
    staticClass: "txt-center"
  }, [_vm._v("Resumen de Compra")]), _vm._v(" "), _c('div', {
    staticClass: "summary-amounts"
  }, [_c('p', {
    staticClass: "subtotal d-flex space-between align-center mx-3 fontAvenirBold"
  }, [_c('span', [_vm._v("Subtotal")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.getCurrencySymbol) + " " + _vm._s(_vm._f("priceFormat")(_vm.orderSummaryInfo.subtotal)))])]), _vm._v(" "), _c('p', {
    staticClass: "delivery d-flex space-between align-center mx-3"
  }, [_c('span', [_vm._v("Envio")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.getCurrencySymbol) + " " + _vm._s(_vm._f("priceFormat")(_vm.orderSummaryInfo.costShipping)))])])]), _vm._v(" "), _c('h3', {
    staticClass: "d-flex align-center space-between mx-3"
  }, [_c('span', [_vm._v("Total")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.getCurrencySymbol) + " " + _vm._s(_vm._f("priceFormat")(_vm.orderSummaryInfo.total)))])])]), _vm._v(" "), _c('div', {
    staticClass: "card-payment"
  }, [_c('h3', {
    staticClass: "txt-center"
  }, [_vm._v("Método de pago")]), _vm._v(" "), _c('div', {
    staticClass: "summary-payment"
  }, [_c('p', {
    staticClass: "txt-center my-2"
  }, [_vm._v(_vm._s(_vm.wayPayment))])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e880ea0","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/summary/summaryOrder.vue
// module id = 1087
// module chunks = 44